import { updateObject } from "utils/helpers/updateObject";
import { actionTypes, DcddDataReport, FetchDcddTotalUserByFilterFailureAction, FetchDcddTotalUserByFilterRequestAction, FetchDcddTotalUserByFilterSuccessAction, FetchDcddTotalUserFailureAction, FetchDcddTotalUserRequestAction, FetchDcddTotalUserSuccessAction, ResetDcddFilterDataAction, stateStatusType } from "./actionType";
import { DcddTotalUserState, initialState } from "./state";

const FetchDcddTotalUsersRequest = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserRequestAction
) => {
  return updateObject(state, {
    dcddTotalUsersState: {
      ...state.dcddTotalUsersState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchDcddTotalUsersSuccess = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserSuccessAction
) => {
  return updateObject(state, {
    dcddTotalUsersState: {
      ...state.dcddTotalUsersState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      dcddTotalUser: action.payload,
    },
  });
};

const FetchDcddTotalUsersFail = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserFailureAction
) => {
  return updateObject(state, {
    dcddTotalUsersState: {
      ...state.dcddTotalUsersState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      dcddTotalUser: null,
    },
  });
};


const FetchDcddTotalUsersByFiterRequest = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserByFilterRequestAction
) => {
  return updateObject(state, {
    dcddTotalUserByFilterState: {
      ...state.dcddTotalUserByFilterState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchDcddTotalUsersByFiterSuccess = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserByFilterSuccessAction
) => {
  return updateObject(state, {
    dcddTotalUserByFilterState: {
      ...state.dcddTotalUserByFilterState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      dcddTotalUserByFilter: action.payload,
    },
  });
};

const FetchDcddTotalUsersByFiterFail = (
  state: DcddTotalUserState,
  action: FetchDcddTotalUserByFilterFailureAction
) => {
  return updateObject(state, {
    dcddTotalUserByFilterState: {
      ...state.dcddTotalUserByFilterState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      dcddTotalUserByFilter: null,
    },
  });
};


//reset 
const resetDcddFiterData = (state: DcddTotalUserState, action:ResetDcddFilterDataAction) => ({
  ...state,
  dcddTotalUserByFilterState:{...initialState.dcddTotalUserByFilterState}

});

const dcddTotalDataReducer = (
  state = initialState,
  action: DcddDataReport
) => {
  switch (action.type) {
    case actionTypes.FETCH_DCDD_TOTAL_USER_REQUEST:
      return FetchDcddTotalUsersRequest(state, action);
    case actionTypes.FETCH_DCDD_TOTAL_USER_SUCCESS:
      return FetchDcddTotalUsersSuccess(state, action);
    case actionTypes.FETCH_DCDD_TOTAL_USER_FAIL:
      return FetchDcddTotalUsersFail(state, action);
    case actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_REQUEST:
      return FetchDcddTotalUsersByFiterRequest(state, action);
    case actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_SUCCESS:
      return FetchDcddTotalUsersByFiterSuccess(state, action);
    case actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_FAIL:
      return FetchDcddTotalUsersByFiterFail(state, action);
    case actionTypes.RESET_DCDD_FILTER_DATA:
      return resetDcddFiterData(state, action);
    default:
      return state;
  }
};
export default dcddTotalDataReducer;

